import { random, round2Str } from "../helpers/helpers";
import { vibrationRegistry } from "./vibrationRegistry";

const getStatusFromVelocity = (velocity, limits) => {
    if (velocity > limits.marginal) return "Critical";
    if (velocity > limits.normal) return "Marginal";
    return "Normal";
};

export const generateVibrationLatestListDemo = () => {
    const now = new Date();

    const formatTime = (d) =>
        `${d.getDate().toString().padStart(2, "0")}-${d.toLocaleString(
            "default",
            { month: "short" }
        )}-${d.getFullYear().toString().slice(-2)} ${d
            .getHours()
            .toString()
            .padStart(2, "0")}:${d.getMinutes()
            .toString()
            .padStart(2, "0")}`;

    const lastSeen = formatTime(now);

    const list = [];

    vibrationRegistry.areas.forEach((area) => {
        area.machines.forEach((machine) => {
            machine.motors.forEach((motor) => {
                // 🔹 Generate realistic base velocity
                const baseVelocity = random(
                    motor.limits.normal * 0.4,
                    motor.limits.normal * 0.9
                );

                const velocityAxis1 = baseVelocity + random(-0.2, 0.2);
                const velocityAxis2 = baseVelocity + random(-0.2, 0.2);
                const velocityAxis3 = baseVelocity + random(-0.2, 0.2);

                const maxVelocity = Math.max(
                    velocityAxis1,
                    velocityAxis2,
                    velocityAxis3
                );

                const status = getStatusFromVelocity(
                    maxVelocity,
                    motor.limits
                );

                // 🔹 Acceleration correlates with velocity
                const accBase = maxVelocity * random(0.15, 0.35);

                const temperature = random(
                    motor.limits.temp_normal - 5,
                    motor.limits.temp_normal + 5
                );

                list.push({
                    id: motor.id,
                    meter_id: motor.id,
                    name: motor.motor_name,

                    erc: motor.erc,
                    capacity: motor.capacity,

                    shaft_parallel: motor.shaft_parallel,
                    shaft_perpendicular: motor.shaft_perpendicular,
                    shaft_vertical: motor.shaft_vertical,

                    normal_limit: round2Str(motor.limits.normal),
                    marginal_limit: round2Str(motor.limits.marginal),
                    temp_normal: round2Str(motor.limits.temp_normal),
                    temp_marginal: round2Str(motor.limits.temp_marginal),

                    // ✅ Acceleration (mm/s²)
                    acceleration_axis1: round2Str(accBase + random(-0.05, 0.05)),
                    acceleration_axis2: round2Str(accBase + random(-0.05, 0.05)),
                    acceleration_axis3: round2Str(accBase + random(-0.05, 0.05)),

                    // ✅ Velocity (mm/s)
                    velocity_axis1: round2Str(velocityAxis1),
                    velocity_axis2: round2Str(velocityAxis2),
                    velocity_axis3: round2Str(velocityAxis3),

                    // ✅ Temperature
                    temperature: round2Str(temperature),

                    auto_ai_config_set: true,
                    online: true,
                    status,

                    last_device_time: lastSeen,
                    last_reading_time: lastSeen.slice(0, -3),
                });
            });
        });
    });

    return {
        total: list.length,
        online: list.length,
        offline: 0,
        normal: list.filter((l) => l.status === "Normal").length,
        marginal: list.filter((l) => l.status === "Marginal").length,
        critical: list.filter((l) => l.status === "Critical").length,
        list,
    };
};
